import {
  booleanOperationList,
  campaignOperationList,
  dateOperationList,
  numberOperationList,
  relativeDateOperationList,
  stringOperationList,
} from './operationLists';

// For a given data type, what operators can we use on it?
export const operatorDefinitionsByType = {
  bool: booleanOperationList,
  campaign: campaignOperationList,
  date: [...dateOperationList, ...relativeDateOperationList],
  number: numberOperationList,
  relativeDate: relativeDateOperationList,
  string: stringOperationList,
};
